import { FetchHelper } from '@/globals/FetchHelper';
import { LevelUpAuthorizeParameters, LevelUpAuthResponse, LevelUpTokenGrantParameters, LevelUpTokenGrantResponse } from './pn-level-up.models';
import { LocalStorageService } from '@/globals/LocalStorageService';

export class PnLevelUpService {
  private readonly _endpoint;
  private readonly _levelupAuthorizePath = `/api/levelup/level-up-authorize`;
  private readonly _levelupTokenGrantPath = `/api/levelup/level-up-token-grant`;
  private readonly levelupLocalStorageKey = 'levelup';
  
  private fetchHelper = new FetchHelper('PnLevelUpService');
  private _storage: LocalStorageService = new LocalStorageService();

  constructor(endpoint: string) {
    this._endpoint = this.formatEndpoint(endpoint);
  }

  public newLevelupUser() {
    let threeMinutesInMilliseconds = 180000;
    this._storage.set(this.levelupLocalStorageKey, { expire: Date.now() + threeMinutesInMilliseconds });
  }

  public async levelupAuthorize(system: string, defaultReturn: LevelUpAuthResponse) : Promise<LevelUpAuthResponse> {
    if (!system) {
      return defaultReturn;
    }

    let model: LevelUpAuthorizeParameters = {
      system: system
    };

    const fetchUrl = this._endpoint + this._levelupAuthorizePath;
    const data = (await this.fetchHelper.fetchJson(
      fetchUrl,
      this.getRequestInit(model),
      false,
    )) as string;

    return this.handleResponse<LevelUpAuthResponse>(data, defaultReturn);
  }
  
  public async levelupTokenGrant(id: string, loopSeconds: string, defaultReturn: LevelUpTokenGrantResponse) : Promise<LevelUpTokenGrantResponse> {
    if (!id) {
      return defaultReturn;
    }

    let model: LevelUpTokenGrantParameters = {
      id: id,
      loopSeconds: loopSeconds
    };

    const fetchUrl = this._endpoint + this._levelupTokenGrantPath;
    const data = (await this.fetchHelper.fetchJson(
      fetchUrl,
      this.getRequestInit(model),
      false,
    )) as string;

    return this.handleResponse<LevelUpTokenGrantResponse>(data, defaultReturn);
  }
  
  private formatEndpoint(endpoint: string) : string {
    return endpoint.lastIndexOf('/') === endpoint.length - 1 ? endpoint.substring(0, endpoint.length - 1) : endpoint;
  }

  private handleResponse<T>(data : any, defaultReturn : any, checkForArray: boolean = false) {
    if (!data) {
      return defaultReturn;
    }

    let parsedData = JSON.parse(data) as T;
    if (!parsedData || checkForArray && !Array.isArray(parsedData)) {
      return defaultReturn;
    }

    return parsedData;
  }
  
  private getRequestInit(model: any, method: string = 'POST', mode: RequestMode = 'cors', contentTypes: string = 'application/json'): RequestInit {
    return {
      mode: mode,
      method: method,
      headers: 
      {
        'Content-Type': contentTypes,
        'CustomValidateAntiForgeryToken': "0111000001101110011000110110000101110100"
      },
      body: JSON.stringify(model)
    };
  }
}